export const APPEND_PERMISSIONS = 'APPEND_PERMISSIONS';

export function appendPermissions(permissions, applet) {
    return { type: APPEND_PERMISSIONS, permissions, applet };
}